import { useState } from 'react';
import { c } from './cajeroShared';
import NoteEditor from './NoteEditor';
import DocList from './DocList';

// Envuelve crear/ver de notas crédito o débito.
function NotesView({ token, noteType, typeLabel, onBack }) {
  const [mode, setMode] = useState('menu'); // menu | crear | ver

  if (mode === 'crear') return <NoteEditor token={token} noteType={noteType} typeLabel={typeLabel} onBack={() => setMode('menu')} />;
  if (mode === 'ver') return <DocList token={token} type={noteType} typeLabel={`${typeLabel}s`} onBack={() => setMode('menu')} />;

  return (
    <div style={{ maxWidth: 700, margin: '0 auto', padding: '1.5rem 1rem 4rem' }}>
      <button onClick={onBack} style={{ background: 'none', border: `1px solid ${c.border}`, color: c.text, borderRadius: '7px', padding: '8px 14px', cursor: 'pointer', fontSize: '0.85rem', fontFamily: 'inherit' }}>← Volver al cajero</button>
      <h1 style={{ color: c.primary, fontSize: '1.4rem', margin: '12px 0 20px' }}>{typeLabel}s</h1>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '14px' }}>
        <button onClick={() => setMode('crear')} style={cardBtn}>
          <div style={{ fontSize: '1.8rem' }}>✏️</div>
          <div style={{ fontWeight: 600 }}>Crear {typeLabel.toLowerCase()}</div>
          <div style={{ color: c.textMuted, fontSize: '0.82rem' }}>A partir de una factura</div>
        </button>
        <button onClick={() => setMode('ver')} style={cardBtn}>
          <div style={{ fontSize: '1.8rem' }}>📋</div>
          <div style={{ fontWeight: 600 }}>Ver {typeLabel.toLowerCase()}s</div>
          <div style={{ color: c.textMuted, fontSize: '0.82rem' }}>Notas creadas y su estado</div>
        </button>
      </div>
    </div>
  );
}

const cardBtn = { textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit', background: c.surface, border: `1px solid ${c.border}`, borderRadius: '12px', padding: '20px', color: c.text, display: 'flex', flexDirection: 'column', gap: '6px' };

export default NotesView;
